import React from 'react';
import style from './preview-content.module.scss';
import { DeleteIcon, EditIcon } from '../../../../chat/icons';
import { SetState } from '../../../../chat/types';
import lodash from 'lodash';

// icons
import DragIcon from '../../../../../../../assets/svg/solo-chat/drag-handle-2.svg';
import TextIcon from '../../../../../../../assets/svg/solo-chat/content-types/text.svg';
import SimpleChoiceIcon from '../../../../../../../assets/svg/solo-chat/content-types/simple-choice.svg';
import CardChoiceIcon from '../../../../../../../assets/svg/solo-chat/content-types/card-choice.svg';
import AutocompleteIcon from '../../../../../../../assets/svg/solo-chat/content-types/autocomplete.svg';
import ImageIcon from '../../../../../../../assets/svg/solo-chat/content-types/image.svg';
import MarkdownIcon from '../../../../../../../assets/svg/solo-chat/content-types/markdown.svg';
import PdfIcon from '../../../../../../../assets/svg/solo-chat/content-types/pdf.svg';
import AdaptiveCardIcon from '../../../../../../../assets/svg/solo-chat/content-types/adaptive-card.svg';
import CarouselIcon from '../../../../../../../assets/svg/solo-chat/content-types/carousel.svg';
import DynamicMsgIcon from '../../../../../../../assets/svg/solo-chat/content-types/dynamic-msg.svg';
import { AttachedMsg } from '../types';
import { Content } from '../../../../chat/pages/content/types';
import { labelMap } from '.';

type Props = {
	index: number;
	removeAction: (index: number) => void;
	setEditAction: SetState<any>;
	lock: boolean;
	msg: AttachedMsg;
	contents: Content[]
};

export function PreviewContent(props: Props) {
	const { removeAction, index, setEditAction, lock, msg, contents } = props;
	const content = contents.find((content) => !msg.isDynamic && content.contentId === msg.contentId);

	const title = msg.isDynamic
		? msg.title
		: content ? (content.contentValue as any)[labelMap[content.contentType]] : ''

	const contentType = content?.contentType ?? ''

	if(!title) {
		return null
	}

	return (
		<div className={style.previewContent} data-lock={lock}>
			<div title={lodash.startCase(contentType)}>
				{!lock && <img className="drag-handle" src={DragIcon} alt="reorder" />}
				{contentType && (
					<img src={iconMap[contentType]} alt="preview content" />
				)}
				{msg.isDynamic && <img src={DynamicMsgIcon} alt='dynamic message' />}
				<p>{title}</p>
			</div>
			<div>
				<button onClick={() => removeAction(index)}>
					<DeleteIcon width="14" height="14" stroke="#8C8F94" />
				</button>
				<button
					onClick={() =>
						setEditAction({
							index,
							...msg,
							contentType
						})
					}
				>
					<EditIcon width="14" height="14" stroke="#8C8F94" />
				</button>
			</div>
		</div>
	);
}

const iconMap: Record<string, string> = {
	text: TextIcon,
	simpleChoice: SimpleChoiceIcon,
	cardChoice: CardChoiceIcon,
	pdf: PdfIcon,
	image: ImageIcon,
	autoComplete: AutocompleteIcon,
	adaptiveCard: AdaptiveCardIcon,
	markdown: MarkdownIcon,
	cardCarousel: CarouselIcon,
};
